import type Income from '../incomes.ts/model'
import type Webinar from '../webinars/model'

export type Peer = {
  id: string
  name: string
  username: string
}

export type Shift = {
  id: number
  date: Date
  time: string
  is_intern: boolean
  incomes: Income[]
}

export default interface Chatter {
  id: number
  name: string
  age: number
  city: string
  country: string
  language: 'ru' | 'en' | 'uk'
  shifts: string[]
  webinar: Webinar
  tg_peers: Peer[]
  created_at: string
  invited_by_id: number | null
  invited_chatters: Chatter[]
  status: ChatterStatus
  assigned_shifts: Shift[]
  comment?: string
  status_changed_at: Date
  messages_count: number
  last_message_at: Date
  referrer_username: string | null
  curator_id?: number
  income_photos: {
    [incomeId: number]: string[]
  }
  profile_photos: string[]
  assessments: Array<{
    id: number
    test_id: number
    is_sent: boolean
    send_at: Date
    has_passed: boolean | null
    reason: string | null
    score: number | null
    completed_at: Date | null
    excellent_performance: boolean | null
    questions: Array<{
      id: number
      index: number
      question: string
      type: string
      options: string[]
      correct_answer: string
      user_answer: string | null
      is_correct: boolean | null
      explanation: string | null
    }>
  }>
  manual_nudges: Array<{
    id: number
    chatter_id: number
    stage: ChatterStatus
    manual_nudge_outcome_id: number
    comment: string | null
    created_at: Date
    deleted_at: Date | null
  }>
}

export interface ChattersListRequest {
  page?: number
  limit?: number
  status?: ChatterStatus
  username?: string
  referral?: string
  inactiveDays?: number
  nudged?: boolean
  from?: Date
  to?: Date
}

export interface ChattersListResponse {
  items: Chatter[]
  total: number
  stats: Partial<Record<ChatterStatus, number>>
}

export type SaveChatter = {
  name: string
  age: number
  city: string
  country: string
  shifts: string[]
  webinar_id: number | null
  invited_by_id: number | null
  status: ChatterStatus
  comment?: string
  curator_id?: number
}

export enum ChatterStatus {
  INIT = 'INIT',
  PROFILE_FILLED = 'PROFILE_FILLED',
  CONDITIONS_SENT = 'CONDITIONS_SENT',
  SIGNED_TO_WEBINAR = 'SIGNED_TO_WEBINAR',
  WEBINAR_CODE_PROVIDED = 'WEBINAR_CODE_PROVIDED',
  CONDITIONS_CONFIRMED = 'CONDITIONS_CONFIRMED',
  TEST_PASSED = 'TEST_PASSED',
  VERIFIED = 'VERIFIED',
  ZERO_SHIFT = 'ZERO_SHIFT',
  FIFTH_SHIFT = 'FIFTH_SHIFT',
  TEAM = 'TEAM',
}
